import { API_CONFIG } from '../../config/api';
import type { VulnerabilitiesResponse, VulnerabilitiesApiError } from './types';

export interface GetVulnerabilitiesParams {
  days?: number;
  token: string;
  ownership?: 'enterpriseOwned' | 'locallyOwned';
  source?: 'sowb' | 'assessments';
}

/**
 * Fetch aggregated vulnerabilities data for groups owned by the current consultant/admin
 * (locallyOwned) or for enterprise-assigned students (enterpriseOwned).
 */
export const getConsultantVulnerabilities = async (
  params: GetVulnerabilitiesParams
): Promise<VulnerabilitiesResponse> => {
  try {
    const { token, days = 30, ownership, source = 'sowb' } = params;

    const url = new URL(API_CONFIG.ENDPOINTS.CONSULTANT_VULNERABILITIES);
    url.searchParams.set('days', days.toString());
    if (ownership) {
      url.searchParams.set('ownership', ownership);
    }
    url.searchParams.set('source', source);

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch vulnerabilities data');
    }

    return data;
  } catch (error) {

    throw error;
  }
};

/**
 * Helper function to get auth token from localStorage
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem('token');
};

/**
 * Helper function to handle API errors consistently
 */
export const handleApiError = (error: any): VulnerabilitiesApiError => {
  if (error.message) {
    return {
      success: false,
      message: error.message
    };
  }

  return {
    success: false,
    message: 'An unexpected error occurred'
  };
};
